<ion-modal
  #questionsJournalModal
  id="questions-journal-modal"
  [backdropDismiss]="false"
  [handle]="false"
  [isOpen]="open()"
  (didDismiss)="onDidDismissModal()"
  (didPresent)="onDidPresentModal()"
  (willDismiss)="onWillDismissModal()"
>
  <ng-template>
    <div
      class="flex flex-col justify-between gap-6 h-full py-9"
      [class.justify-between]="mappingQuestionsAndAnswers().length > 0"
    >
      <div class="flex items-center justify-center gap-2">
        <ion-icon
          class="size-[38px]"
          src="/assets/icons/lwb/home/daily-check-in.svg"
        ></ion-icon>
        <p class="text-black font-semibold text-base">My Check-In</p>
      </div>
      <section class="flex flex-col px-4 overflow-auto">
        <div>
          <p class="text-black font-semibold text-base">
            Hello {{ profileName() }}, <br />
            Whats happened on {{ date() | date: 'dd LLLL yyyy' }}?
          </p>
          <p class="text-black-70 text-xs">
            Tell us how your day went yesterday. What happened with your health,
            mental state, and nutrition intake?
          </p>
        </div>
        <!-- Questions -->
        @defer (on timer(1000ms)) {
          @if (questionsError()) {
            <div
              class="w-full flex flex-col justify-center items-center h-[300px] text-center px-4"
            >
              <div class="text-sm font-medium text-dark mb-2">
                Unable to fetch questions
              </div>
              <div>
                <span class="text-sm text-dark">
                  <strong class="text-sm text-dark">Retry</strong></span
                >
                <button
                  class="ml-1 active:opacity-80 p-[6px] inline-flex align-middle items-center justify-center rounded-full border border-solid"
                  [style.border-color]="'rgba(120, 150, 177, 0.25)'"
                  (click)="fetch()"
                >
                  <ion-icon color="dark" name="refresh-outline"></ion-icon>
                </button>
              </div>
            </div>
          } @else {
            <div>
              @for (
                type of mappingQuestionsAndAnswers();
                track type.dailyJournalType?.id
              ) {
                <div class="my-4">
                  <div
                    class="w-full flex flex-row items-center justify-between gap-5 py-3"
                  >
                    <div class="flex-initial text-xs text-[#9E9E9E]">
                      {{ type.dailyJournalType?.name }}
                    </div>
                    <div class="grow">
                      <div
                        class="w-full border-b border-[#E0E0E0] border-solid"
                      ></div>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2">
                    @for (q of type.questions; track q.id) {
                      <!-- Main Question -->
                      @if (q.dailyJournalQuestion.isFollowUp === false) {
                        <div class="w-full">
                          <div
                            class="flex flex-row items-center justify-between"
                          >
                            <div class="flex-grow">
                              <div
                                class="block text-sm text-black font-bold leading-none"
                              >
                                {{ q.dailyJournalQuestion.question }}
                              </div>
                            </div>
                            <div flex="flex-initial">
                              <div class="flex flex-row items-center">
                                @if (
                                  q.dailyJournalQuestion.responseType ===
                                  dailyJournalQuestionResponseType.BOOLEAN
                                ) {
                                  <ion-button
                                    class="p-0 m-0"
                                    fill="clear"
                                    size="small"
                                    (click)="
                                      setValueQuestionAnswer(
                                        $any(q),
                                        true,
                                        dailyJournalQuestionResponseType.BOOLEAN,
                                        true
                                      )
                                    "
                                  >
                                    <ion-icon
                                      class="text-4xl"
                                      name="checkmark-circle-outline"
                                      slot="icon-only"
                                      [style.color]="
                                        mappingAnswersByQuestionId().get(
                                          q.dailyJournalQuestionId
                                        )?.answer === true
                                          ? 'var(--ion-color-pink)'
                                          : '#E0E0E0'
                                      "
                                    ></ion-icon>
                                  </ion-button>
                                  <ion-button
                                    class="p-0 m-0"
                                    fill="clear"
                                    size="small"
                                    (click)="
                                      setValueQuestionAnswer(
                                        $any(q),
                                        false,
                                        dailyJournalQuestionResponseType.BOOLEAN,
                                        true
                                      )
                                    "
                                  >
                                    <ion-icon
                                      class="text-4xl"
                                      name="close-circle-outline"
                                      slot="icon-only"
                                      [style.color]="
                                        mappingAnswersByQuestionId().get(
                                          q.dailyJournalQuestionId
                                        )?.answer === false
                                          ? 'var(--ion-color-pink)'
                                          : '#E0E0E0'
                                      "
                                    ></ion-icon>
                                  </ion-button>
                                } @else if (
                                  q.dailyJournalQuestion.responseType ===
                                  dailyJournalQuestionResponseType.CUSTOM_VARIABLE
                                ) {
                                  @if (
                                    q.dailyJournalQuestion.responseFormat &&
                                    q.dailyJournalQuestion.responseFormat
                                      .typeCustomVariable ===
                                      dailyJournalQuestionResponseFormatType.SLIDER
                                  ) {
                                    <p class="text-xs leading-none">
                                      {{
                                        mappingAnswersByQuestionId().get(
                                          q.dailyJournalQuestionId
                                        )
                                          | get
                                            : 'answer.name'
                                            : getValueInputRangeHandler(
                                                q.dailyJournalQuestion
                                                  .responseFormat.options || [],
                                                mappingAnswersByQuestionId().get(
                                                  q.dailyJournalQuestionId
                                                ) | get: 'answer'
                                              )?.answer?.name
                                      }}
                                    </p>
                                  } @else if (
                                    q.dailyJournalQuestion.responseFormat &&
                                    q.dailyJournalQuestion.responseFormat
                                      .typeCustomVariable ===
                                      dailyJournalQuestionResponseFormatType.SELECTION
                                  ) {
                                    <p>selection</p>
                                  }
                                }
                              </div>
                            </div>
                          </div>

                          @if (
                            q.dailyJournalQuestion.responseType ===
                            dailyJournalQuestionResponseType.CUSTOM_VARIABLE
                          ) {
                            @if (
                              q.dailyJournalQuestion.responseFormat &&
                              q.dailyJournalQuestion.responseFormat
                                .typeCustomVariable ===
                                dailyJournalQuestionResponseFormatType.SLIDER
                            ) {
                              <!-- Range with gradient color -->
                              <div class="range-wrapper">
                                <div class="native-wrapper">
                                  <div class="range-bg">
                                    <div
                                      class="range-bg--diagonal-part"
                                      [class.range-bg--high-better]="
                                        q.dailyJournalQuestion.responseFormat
                                          .isHigherBetter
                                      "
                                    ></div>
                                    <div class="range-bg--thumb">
                                      @for (
                                        dot of q.dailyJournalQuestion
                                          .responseFormat.options || [];
                                        track $index
                                      ) {
                                        <div class="dot-wrapper">
                                          <div class="dot"></div>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                  <input
                                    class="native-input"
                                    data-testid="range-value"
                                    min="1"
                                    type="range"
                                    [max]="5"
                                    [style.paddingInline.px]="
                                      datalist.offsetWidth /
                                        (
                                          q.dailyJournalQuestion.responseFormat
                                            .options || []
                                        ).length /
                                        2 -
                                      7
                                    "
                                    [value]="
                                      getValueInputRangeHandler(
                                        q.dailyJournalQuestion.responseFormat
                                          .options || [],
                                        mappingAnswersByQuestionId().get(
                                          q.dailyJournalQuestionId
                                        ) | get: 'answer'
                                      )?.index
                                    "
                                    (input)="
                                      onChangeInputRangeHandler(
                                        $event,
                                        q.dailyJournalQuestion.responseFormat
                                          .options || [],
                                        $any(q)
                                      )
                                    "
                                  />
                                  <div #datalist class="datalist">
                                    @for (
                                      item of q.dailyJournalQuestion
                                        .responseFormat.options || [];
                                      track $index;
                                      let dailyJournalQuestionResponseFormatIndex = $index
                                    ) {
                                      <p
                                        role="button"
                                        (click)="
                                          onClickTitleInputRangeHandler(
                                            dailyJournalQuestionResponseFormatIndex,
                                            q.dailyJournalQuestion
                                              .responseFormat.options || [],
                                            $any(q)
                                          )
                                        "
                                      >
                                        {{ item.name }}
                                      </p>
                                    }
                                  </div>
                                </div>
                              </div>
                            } @else if (
                              q.dailyJournalQuestion.responseFormat &&
                              q.dailyJournalQuestion.responseFormat
                                .typeCustomVariable ===
                                dailyJournalQuestionResponseFormatType.SELECTION
                            ) {
                              <p>selection option</p>
                            }
                          }
                        </div>
                      }

                      <!-- Follow Up Question -->
                      @if (
                        q.dailyJournalQuestion.mainQuestionId === null &&
                        q.dailyJournalQuestion.responseType ===
                          dailyJournalQuestionResponseType.BOOLEAN &&
                        mappingAnswersByQuestionId().get(
                          q.dailyJournalQuestionId
                        )?.answer === true
                      ) {
                        @for (
                          fq of mappingFollowUpQuestions().get(
                            q.dailyJournalQuestionId
                          ) || [];
                          track fq.id;
                          let isLast = $last
                        ) {
                          <div
                            class="w-full transition-all"
                            [ngClass]="{ 'mb-2': isLast }"
                          >
                            <div>
                              <div
                                class="flex flex-row items-center justify-between gap-3"
                              >
                                <div class="flex-grow">
                                  <div
                                    class="block text-xs text-[#757575] font-normal leading-none"
                                  >
                                    {{ fq.dailyJournalQuestion.question }}
                                  </div>
                                </div>
                                <div class="flex flex-row items-center">
                                  @if (
                                    fq.dailyJournalQuestion.responseType ===
                                    dailyJournalQuestionResponseType.BOOLEAN
                                  ) {
                                    <ion-button
                                      class="p-0 m-0"
                                      fill="clear"
                                      size="small"
                                      (click)="
                                        setValueQuestionAnswer(
                                          fq,
                                          true,
                                          dailyJournalQuestionResponseType.BOOLEAN,
                                          true
                                        )
                                      "
                                    >
                                      <ion-icon
                                        class="text-4xl"
                                        name="checkmark-circle-outline"
                                        slot="icon-only"
                                        [style.color]="
                                          mappingAnswersByQuestionId().get(
                                            fq.dailyJournalQuestionId
                                          )?.answer === true
                                            ? 'var(--ion-color-pink)'
                                            : '#E0E0E0'
                                        "
                                      ></ion-icon>
                                    </ion-button>
                                    <ion-button
                                      class="p-0 m-0"
                                      fill="clear"
                                      size="small"
                                      (click)="
                                        setValueQuestionAnswer(
                                          fq,
                                          false,
                                          dailyJournalQuestionResponseType.BOOLEAN,
                                          true
                                        )
                                      "
                                    >
                                      <ion-icon
                                        class="text-4xl"
                                        name="close-circle-outline"
                                        slot="icon-only"
                                        [style.color]="
                                          mappingAnswersByQuestionId().get(
                                            fq.dailyJournalQuestionId
                                          )?.answer === false
                                            ? 'var(--ion-color-pink)'
                                            : '#E0E0E0'
                                        "
                                      ></ion-icon>
                                    </ion-button>
                                  } @else if (
                                    fq.dailyJournalQuestion.responseType ===
                                    dailyJournalQuestionResponseType.INPUT_NUMBER
                                  ) {
                                    <ion-button
                                      class="p-0 m-0"
                                      fill="clear"
                                      size="small"
                                      [disabled]="
                                        toNumber(
                                          mappingAnswersByQuestionId().get(
                                            fq.dailyJournalQuestionId
                                          )?.answer ?? fq.answer
                                        ) <= 0
                                          ? true
                                          : false
                                      "
                                      (click)="
                                        setValueQuestionAnswer(
                                          fq,
                                          'decrement',
                                          dailyJournalQuestionResponseType.INPUT_NUMBER,
                                          true
                                        )
                                      "
                                    >
                                      <ion-icon
                                        class="text-[#E0E0E0] text-4xl"
                                        name="remove-circle-outline"
                                        slot="icon-only"
                                      ></ion-icon>
                                    </ion-button>
                                    <div class="min-w-6">
                                      <div
                                        class="text-sm w-full flex text-center justify-center"
                                      >
                                        {{
                                          mappingAnswersByQuestionId().get(
                                            fq.dailyJournalQuestionId
                                          )?.answer ?? fq.answer
                                        }}
                                      </div>
                                    </div>
                                    <ion-button
                                      class="p-0 m-0"
                                      fill="clear"
                                      size="small"
                                      (click)="
                                        setValueQuestionAnswer(
                                          fq,
                                          'increment',
                                          dailyJournalQuestionResponseType.INPUT_NUMBER,
                                          true
                                        )
                                      "
                                    >
                                      <ion-icon
                                        class="text-[#E0E0E0] text-4xl"
                                        name="add-circle-outline"
                                        slot="icon-only"
                                      ></ion-icon>
                                    </ion-button>
                                  } @else if (
                                    fq.dailyJournalQuestion.responseType ===
                                    dailyJournalQuestionResponseType.TIME_SELECTION
                                  ) {
                                    <p class="text-xs">
                                      {{
                                        mappingAnswersByQuestionId().get(
                                          fq.dailyJournalQuestionId
                                        )?.answer ||
                                          getValueIonRangeHandler(
                                            mappingAnswersByQuestionId().get(
                                              fq.dailyJournalQuestionId
                                            )?.answer
                                          ).answer
                                      }}
                                    </p>
                                  }
                                </div>
                              </div>
                            </div>

                            @if (
                              fq.dailyJournalQuestion.responseType ===
                              dailyJournalQuestionResponseType.TIME_SELECTION
                            ) {
                              <div>
                                <ion-range
                                  aria-label="range time selection"
                                  [max]="47"
                                  [min]="0"
                                  [ngStyle]="{
                                    '--bar-background': '#e4e4e4',
                                    '--bar-background-active': '#e4e4e4'
                                  }"
                                  [value]="
                                    getValueIonRangeHandler(
                                      mappingAnswersByQuestionId().get(
                                        fq.dailyJournalQuestionId
                                      )?.answer
                                    ).index
                                  "
                                  (ionInput)="
                                    onChangeIonRangeForTimeSelectionHandler(
                                      $event,
                                      fq
                                    )
                                  "
                                ></ion-range>
                              </div>
                            } @else if (
                              fq.dailyJournalQuestion.responseType ===
                                dailyJournalQuestionResponseType.CUSTOM_VARIABLE &&
                              fq.dailyJournalQuestion.responseFormat &&
                              fq.dailyJournalQuestion.responseFormat
                                .typeCustomVariable ===
                                dailyJournalQuestionResponseFormatType.SELECTION
                            ) {
                              <div class="grid grid-cols-2 gap-2.5 mt-2">
                                @for (
                                  qcvs of fq.dailyJournalQuestion.responseFormat
                                    .options || [];
                                  track `custom-selection-${qcvs.id}`;
                                  let qcvsFirst = $first
                                ) {
                                  <div
                                    class="custom-variable-selection ion-activatable"
                                    role="button"
                                    [ngClass]="{
                                      '!border-primary-black pointer-events-none':
                                        (mappingAnswersByQuestionId().get(
                                          fq.dailyJournalQuestionId
                                        ) | get: 'answer.id') === qcvs.id,
                                      'opacity-50':
                                        (mappingAnswersByQuestionId().get(
                                          fq.dailyJournalQuestionId
                                        ) | get: 'answer.id') &&
                                        (mappingAnswersByQuestionId().get(
                                          fq.dailyJournalQuestionId
                                        ) | get: 'answer.id') !== qcvs.id
                                    }"
                                    (click)="
                                      setValueQuestionAnswer(
                                        fq,
                                        qcvs,
                                        dailyJournalQuestionResponseType.CUSTOM_VARIABLE,
                                        true
                                      )
                                    "
                                  >
                                    <ion-ripple-effect></ion-ripple-effect>
                                    <!-- special condition for WORK_COMMUTE_FO_1 -->
                                    @if (
                                      fq.dailyJournalQuestion.code ===
                                      'WORK_COMMUTE_FO_1'
                                    ) {
                                      <div class="h-8">
                                        @if (qcvsFirst) {
                                          <ion-icon
                                            class="text-3xl leading-none transition-all"
                                            src="/assets/images/daily/journal/commute-private.svg"
                                            [ngClass]="{
                                              'text-primary-black':
                                                (mappingAnswersByQuestionId().get(
                                                  fq.dailyJournalQuestionId
                                                ) | get: 'answer.id') ===
                                                qcvs.id
                                            }"
                                          ></ion-icon>
                                        } @else {
                                          <ion-icon
                                            class="text-3xl leading-none transition-all"
                                            src="/assets/images/daily/journal/commute-public.svg"
                                            [ngClass]="{
                                              'text-primary-black':
                                                (mappingAnswersByQuestionId().get(
                                                  fq.dailyJournalQuestionId
                                                ) | get: 'answer.id') ===
                                                qcvs.id
                                            }"
                                          ></ion-icon>
                                        }
                                      </div>
                                    }
                                    <p
                                      class="text-xs text-center leading-none transition-all"
                                      [ngClass]="{
                                        'text-primary-black':
                                          (mappingAnswersByQuestionId().get(
                                            fq.dailyJournalQuestionId
                                          ) | get: 'answer.id') === qcvs.id
                                      }"
                                    >
                                      {{ qcvs.name }}
                                    </p>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                      }
                    }
                  </div>
                </div>
              }
            </div>
          }
        } @placeholder {
          <div class="h-full w-full my-4">
            <ion-skeleton-text
              animated
              class="h-[300px] w-full rounded-md"
            ></ion-skeleton-text>
          </div>
        }
      </section>
      <div class="flex flex-col gap-2">
        <ion-button
          class="mx-auto w-44"
          color="main-button"
          shape="round"
          [disabled]="
            !validationSubmitDailyJournal() ||
            mappingQuestionsAndAnswers().length <= 0 ||
            questionsError()
          "
          (click)="submitDailyJournal()"
          >Submit</ion-button
        >
        <p
          class="underline text-xs text-dark text-center"
          (click)="doThisLater()"
        >
          Do this later
        </p>
      </div>
    </div>
  </ng-template>
</ion-modal>
